import { render, staticRenderFns } from "./BackgroundScreening.vue?vue&type=template&id=69c9c590&scoped=true"
import script from "./BackgroundScreening.vue?vue&type=script&lang=js"
export * from "./BackgroundScreening.vue?vue&type=script&lang=js"
import style0 from "./BackgroundScreening.vue?vue&type=style&index=0&id=69c9c590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9c590",
  null
  
)

export default component.exports